module.exports = __webpack_public_path__ + "img/arreglalo_logo_300.d80d272a.png";